/**
 * Configuration for Approver Form Radio Button Options
 * Centralized options to avoid repetition across approval forms
 */

export interface RadioOption {
  id: string
  value: string
  label: string
}

/**
 * Base radio button options available across all approval forms
 * Individual forms will apply their own disabled conditions
 */
export const RADIO_OPTIONS: RadioOption[] = [
  {
    id: 'approved',
    value: 'approved',
    label: 'Approved',
  },
  {
    id: 'denied',
    value: 'denied',
    label: 'Denied',
  },
  {
    id: 'hold',
    value: 'hold',
    label: 'Hold',
  },
  {
    id: 'returned',
    value: 'returned',
    label: 'Returned',
  },
]

/**
 * Partially Approved option - only shown in certain forms with multiple dates
 */
export const PARTIALLY_APPROVED_OPTION: RadioOption = {
  id: 'partiallyapproved',
  value: 'partiallyapproved',
  label: 'Partially Approved/Denied',
}

/**
 * Apply a Request Status heading styling
 */
export const APPLY_REQUEST_STATUS_HEADING = {
  text: 'Select a Request Status',
}

/**
 * Get radio options for a specific form
 * @param formType - Type of form ('approved' | 'denied' | 'hold' | 'partiallyapproved')
 * @param includePartial - Whether to include the "Partially Approved/Denied" option
 */
export const getRadioOptions = (
  includePartial: boolean = false
): RadioOption[] => {
  const options = [...RADIO_OPTIONS]

  if (includePartial) {
    options.push(PARTIALLY_APPROVED_OPTION)
  }

  return options
}
